import React from 'react'

/**
 * Container component for consistent max-width and padding
 * Wraps content sections to maintain consistent layout
 * 
 * @example
 * // Default container
 * <Container>
 *   <h1>Content</h1>
 * </Container>
 * 
 * // Small container
 * <Container size="sm">
 *   <p>Narrow content</p>
 * </Container>
 * 
 * // With custom padding
 * <Container className="py-20">
 *   <div>Custom spacing</div>
 * </Container>
 */

interface ContainerProps {
  children: React.ReactNode
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'full'
  className?: string
}

const Container: React.FC<ContainerProps> = ({
  children,
  size = 'xl',
  className = '',
}) => {
  const sizes = {
    sm: 'max-w-3xl', // 768px
    md: 'max-w-4xl', // 896px
    lg: 'max-w-6xl', // 1152px
    xl: 'max-w-7xl', // 1280px
    full: 'max-w-full',
  }

  return (
    <div className={`mx-auto w-full px-4 sm:px-6 lg:px-8 ${sizes[size]} ${className}`}>
      {children}
    </div>
  )
}

export default Container
